// extracted by mini-css-extract-plugin
export var dateLabel = "_3j-0";
export var dateLabelError = "_3j-1";
export var fullWidth = "_3j-2";
export var smaller = "_3j-3";